import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Collapse,
  Table,
  Select,
  Col,
  Checkbox,
  Radio,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import AvailableCreditTags from "./components/AvailableCreditTags";
import AvailableDebitTags from "./components/AvailableDebitTags";
import TextArea from "antd/es/input/TextArea";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewGLA0500 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountingRulesDetail, setAccountingRulesDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMultipleCreditAccount, setIsMultipleCreditAccount] = useState(false);
  const [isMultipleDebitAccount, setIsMultipleDebitAccount] = useState(false);
  const [allowedCreditTags, setAllowedCreditTags] = useState([]);
  const [allowedDebitTags, setAllowedDebitTags] = useState([]);

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailAccountingRules}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setAccountingRulesDetail(objDetail);
        // console.log(objDetail);

        // ENABLE DELETE BUTTON
        if (BOM.HasPermission("DELETE_ACCOUNTINGRULE")) {
          dispatch({
            type: cnt.RIGHT_DELETE_BTN,
          });
        }

        useForm.setFieldsValue({
          name: objDetail?.name || "",
          description: objDetail?.description || "",
        });

        setIsLoading(false);
      }
    });
  };

  const onApproveReject = (key) => {
    // console.log("key: ", key);
    const url = `${definedApi.ApproveReject}/${state.key}`;

    let action = "";
    let label = state.account;
    let criteria = "";

    switch (key?.toLowerCase()) {
      case "approve":
        action = "Approve ";
        criteria = false;
        break;
      default:
        action = "Reject ";
        criteria = true;
        break;
    }

    let body = {
      method: "PUT",
      disabled: criteria,
      session,
    };

    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        BOM.LoadAlert(cnt.LOAD, "Processing");
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.message || err.error);
          } else {
            BOM.AlertMsg(
              cnt.SUCCESS,
              BOM.handleSuccessMsg(`${state.account} account `)
            );
            navigate("/gla0100");
          }
        });
      },
      function () {
        // No button
      }
    );

    // console.log(body);
    // BOM.GlobalApproveRejectAction(
    //   body,
    //   url,
    //   "gla0100",
    //   "GL Account",
    //   "Approve "
    // );
  };

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = state.name;
    // console.log(body);return

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${definedApi.DeleteAccountingRulesList}/${state.key}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteAccoutingRuleMsg);
              navigate("/gla0500");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/gla0500");
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.AccountingRulesDetail}
        pageItems={appStatic.detailAccountingRulesItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form
          form={useForm}
          initialValues={{ name: accountingRulesDetail?.name }}
          layout="vertical"
          style={{ paddingTop: 20, marginBottom: 50 }}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item
                  name="name"
                  label={<Text strong>{appLabel.accountingRuleName}</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input
                    className="of-bold-disable-input"
                    style={{ width: "30vh" }}
                    disabled
                  />
                </Form.Item>

                <Form.Item
                  name="officeId"
                  label={<Text strong>{appLabel.accountingRuleOffice}</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    className="of-bold-disable-input"
                    style={{ width: "30vh" }}
                    placeholder={accountingRulesDetail.officeName}
                    showSearch
                    disabled
                    // options={officeData}
                  />
                </Form.Item>

                <div style={{ width: "15vh" }}></div>
              </Row>

              <Row>
                <Form.Item
                  name="description"
                  label={
                    <Text strong>{appLabel.accountingRuleDescription}</Text>
                  }
                >
                  <TextArea
                    className="of-bold-disable-input"
                    style={{ width: "45vh", height: "15vh" }}
                    disabled
                  />
                </Form.Item>
              </Row>

              <Row style={{ justifyContent: "space-between" }}>
                <div span={12} style={{ justifyContent: "center" }}>
                  <Title level={4} strong>
                    Debit Account Details
                  </Title>

                  <Radio.Group
                    // onChange={() =>
                    //   setIsMultipleDebitAccount(!isMultipleDebitAccount)
                    // }
                    value={!isMultipleDebitAccount}
                    disabled
                  >
                    <Radio
                      value={accountingRulesDetail.debitAccounts ? true : false}
                    >
                      Fixed Account
                    </Radio>
                    <Radio
                      value={accountingRulesDetail.debitTags ? true : false}
                    >
                      List of Accounts
                    </Radio>
                  </Radio.Group>

                  {isMultipleDebitAccount ? (
                    <div>
                      <AvailableDebitTags
                        tagName={"Debit"}
                        debitTags={setAllowedDebitTags}
                      />
                      <Form.Item>
                        <Checkbox>
                          <Text strong>Allow multiple debit entries</Text>
                        </Checkbox>
                      </Form.Item>
                    </div>
                  ) : accountingRulesDetail?.debitTags ? (
                    <Col style={{ marginTop: 10 }}>
                      <Card
                        style={{
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                        title={`Selected Debit Tags`}
                      >
                        {accountingRulesDetail?.debitTags?.map((tag) => (
                          <Row
                            key={tag?.tag?.id}
                            style={{ marginTop: 0, marginBottom: 20 }}
                          >
                            <div
                              style={{
                                borderBottom: "1px solid #f0f0f0",
                                width: "100%",
                                paddingBottom: 20,
                              }}
                            >
                              <Text>{tag?.tag?.name}</Text>
                            </div>
                          </Row>
                        ))}
                      </Card>
                    </Col>
                  ) : (
                    <Form.Item
                      name="accountToDebit"
                      label={<Text strong>{appLabel.debitRuleType}</Text>}
                      style={{ marginTop: "2%" }}
                    >
                      <Select
                        placeholder={accountingRulesDetail?.debitAccounts?.map(
                          (debitAccount) => debitAccount.name
                        )}
                        style={{ width: "30vh" }}
                        // options={accountData}
                        disabled
                        showSearch
                      />
                    </Form.Item>
                  )}
                </div>

                <div span={12}>
                  <Title level={4} strong style={{ marginBottom: "2%" }}>
                    Credit Account Details
                  </Title>

                  <Radio.Group
                    // onChange={() =>
                    //   setIsMultipleCreditAccount(!isMultipleCreditAccount)
                    // }
                    value={!isMultipleDebitAccount}
                    disabled
                  >
                    <Radio
                      value={
                        accountingRulesDetail.creditAccounts ? true : false
                      }
                    >
                      Fixed Account
                    </Radio>
                    <Radio
                      value={accountingRulesDetail.creditTags ? true : false}
                    >
                      List of Accounts
                    </Radio>
                  </Radio.Group>

                  {isMultipleCreditAccount ? (
                    <div>
                      <AvailableCreditTags
                        tagName="Credit"
                        creditTags={setAllowedCreditTags}
                      />
                      <Form.Item>
                        <Checkbox>
                          <Text strong>Allow multiple credit entries</Text>
                        </Checkbox>
                      </Form.Item>
                    </div>
                  ) : accountingRulesDetail?.creditTags ? (
                    <Col style={{ marginTop: 10 }}>
                      <Card
                        style={{
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                        title={`Selected Credit Tags`}
                      >
                        {accountingRulesDetail?.creditTags?.map((tag) => (
                          <Row
                            key={tag?.tag?.id}
                            style={{ marginTop: 0, marginBottom: 20 }}
                          >
                            <div
                              style={{
                                borderBottom: "1px solid #f0f0f0",
                                width: "100%",
                                paddingBottom: 20,
                              }}
                            >
                              <Text>{tag?.tag?.name}</Text>
                            </div>
                          </Row>
                        ))}
                      </Card>
                    </Col>
                  ) : (
                    <Form.Item
                      name="accountToCredit"
                      label={<Text strong>{appLabel.creditRuleType}</Text>}
                      style={{ marginTop: "2%" }}
                    >
                      <Select
                        placeholder={accountingRulesDetail?.creditAccounts?.map(
                          (creditAccount) => creditAccount.name
                        )}
                        style={{ width: "30vh" }}
                        // options={accountData}
                        disabled
                        showSearch
                      />
                    </Form.Item>
                  )}
                </div>

                <div style={{ width: "15vh" }}></div>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA0500);
